import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { WithNotFound } from '../errors';
import { TransactionsPage } from './transactions';
import { TransactionPage } from './transactionDetails';
import { NotImplementedYet } from '../components/NotImplementedYet';
import { SessionsPage } from './sessions';
import { AllowRoute } from '../auth';
import { SessionPage } from './sessionDetails';
import { VirtualTerminal } from './virtualTerminal';

const PaymentRoutes = () => (
    <WithNotFound>
        <Route
            exact
            path="/:accountId/payments"
            render={(props) => <Redirect to={`/${props.match.params.accountId}/payments/transactions`} />}
        />
        <Route path="/:accountId/payments/transactions" exact component={TransactionsPage} />
        <Route path="/:accountId/payments/sessions" exact component={SessionsPage} />
        <Route path="/:accountId/payments/sessions/:sessionId" exact component={SessionPage} />
        <Route path="/:accountId/payments/transactions/:transactionId" exact component={TransactionPage} />
        <Route
            path="/:accountId/payments/payouts"
            render={(props) => <Redirect to={`/${props.match.params.accountId}/reports/settlements`} />}
        />
        <Route path="/:accountId/payments/payouts/pending" component={NotImplementedYet} />
        <Route path="/:accountId/payments/payouts/settled" component={NotImplementedYet} />
        <AllowRoute
            path="/:accountId/payments/virtual-terminal"
            exact
            component={VirtualTerminal}
            anyOfScopes={[['admin'], ['admin:checkout'], ['write:checkout']]}
        />
        <Redirect
            from="/:accountId/payments/v2-virtual-terminal"
            to="/:accountId/payments/virtual-terminal"
        />
        <Redirect
            from="/:accountId/payments/virtual-terminal/:sessionId"
            to="/:accountId/payments/sessions/:sessionId"
        />
    </WithNotFound>
);

export default PaymentRoutes;
